// extracted by mini-css-extract-plugin
module.exports = {"CoreAnimation":"CoreAnimation_CoreAnimation__wy3eb"};